var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23590",
    "data-name": "Group 23590",
    transform: "translate(-66 -1848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23565",
    "data-name": "Group 23565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49985",
    "data-name": "Path 49985",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 2135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "switch",
    transform: "translate(96 1917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21191",
    "data-name": "Group 21191",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36015",
    "data-name": "Path 36015",
    d: "M0,53.041c.616-1.115,1.494-1.894,2.812-1.42,2.27.817,1.261,2.928,1.654,4.748H118.428c.531,0,1.063-.018,1.592.01,1.639.086,2.518.869,2.5,2.2s-.9,2.057-2.566,2.132c-.53.024-1.062.008-1.593.008H14.169V68.7h119.92V60.672c-1.413,0-2.883.043-4.348-.015-1.08-.043-1.968-.649-1.957-1.734a3.4,3.4,0,0,1,1.01-2.161,3.091,3.091,0,0,1,1.918-.378c3.812-.032,7.625-.016,11.437-.016h1.681V13.8h-2.058q-56.173,0-112.346,0a12.9,12.9,0,0,1-2.017-.113,1.886,1.886,0,0,1-1.7-2.009,1.911,1.911,0,0,1,1.751-2.113,13.517,13.517,0,0,1,2.018-.1q51.251-.007,102.5,0H134.1V1.474H14.185V9.459c1.286,0,2.527-.029,3.767.007,1.692.049,2.657.9,2.612,2.236-.044,1.289-.957,2.072-2.614,2.086-3.908.033-7.818.013-11.726.014H4.344V15.63q0,14.043,0,28.086c0,2.029-1.218,3.208-2.792,2.62C.942,46.11.511,45.414,0,44.933V11.05a2.877,2.877,0,0,1,2.967-1.6c2.163.038,4.327.01,6.732.01,0-1.885-.005-7.417,0-9.18C9.711-2.379,10.307-3,12.92-3Q74.152-3,135.382-3c2.549,0,3.173.631,3.188,3.159.011,1.773,0,7.314,0,9.294,2.263,0,4.368-.007,6.474,0,2.6.011,3.225.643,3.225,3.265q0,22.364,0,44.729c0,2.621-.623,3.251-3.225,3.265-1.93.011-3.86.011-5.79.021a5.5,5.5,0,0,0-.684.126c0,1.615,0,7.048,0,8.713,0,3.113-.488,3.6-3.624,3.6H13.355c-3.207,0-3.653-.455-3.655-3.71,0-1.583,0-6.933,0-8.746-2.334,0-4.534-.027-6.732.011A2.878,2.878,0,0,1,0,59.122Z",
    transform: "translate(0 3)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36016",
    "data-name": "Path 36016",
    d: "M100.972,83.992c-.745-.039-1.251-.053-1.755-.1-1.833-.155-2.72-.993-2.734-2.808q-.058-7.6,0-15.2a2.478,2.478,0,0,1,2.757-2.774q11.359-.079,22.719,0c1.9.012,2.836.978,2.857,2.895q.085,7.516,0,15.032c-.024,1.9-.954,2.715-2.892,2.868-.447.035-.9.058-1.644.105,0,1.041.036,2.038-.008,3.031-.092,2.07-.895,2.988-2.9,3.017q-6.746.1-13.495,0c-2-.028-2.843-1-2.9-3.018-.027-.963,0-1.928,0-3.046m5.251.858h8.738c.176-1.6-.116-3.417.635-4.525.733-1.082,2.53-1.442,4.025-2.2V68.335H101.689V78.622c4.017.561,4.017.561,4.534,6.228",
    transform: "translate(-62.694 -38.496)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36017",
    "data-name": "Path 36017",
    d: "M175.091,84.248c-.2-.143-.24-.2-.291-.207-4.25-.744-4.25-.744-4.251-5.214,0-4.045-.011-8.089,0-12.133.011-2.8.78-3.612,3.513-3.62q10.681-.029,21.361,0c2.645.008,3.476.845,3.493,3.49.027,4.1.007,8.2.007,12.3,0,4.479-.068,4.559-4.582,5.237,0,1,.034,2.061-.008,3.116-.073,1.839-.887,2.787-2.718,2.815q-6.919.105-13.84,0c-1.8-.03-2.622-1.023-2.684-2.855-.034-1.013-.006-2.027-.006-2.93m.7-5.417c5.3-.739,4.308,3.146,4.483,6.117h8.792c.62-5.4.62-5.4,4.737-6.473,0-2.851-.054-5.745.025-8.635.034-1.246-.315-1.692-1.619-1.667-4.034.076-8.07.027-12.106.027h-4.312Z",
    transform: "translate(-110.851 -38.487)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36018",
    "data-name": "Path 36018",
    d: "M249.049,84c-.82-.046-1.329-.06-1.835-.105-1.745-.159-2.684-.942-2.711-2.682q-.116-7.688,0-15.377c.026-1.8,1-2.712,2.845-2.724q11.362-.071,22.726.006c1.955.015,2.747,1.007,2.758,3.122q.036,7.262,0,14.524c-.012,2.241-.81,3.011-3.1,3.149-.391.024-.782.05-1.4.09,0,1.107.034,2.167-.007,3.223-.072,1.806-.925,2.794-2.734,2.821q-6.918.105-13.839,0c-1.753-.027-2.569-.932-2.685-2.679-.071-1.065-.013-2.138-.013-3.365m18.512-5.218V68.211c-5.72,0-11.294-.014-16.868.032-.366,0-1.038.463-1.044.722-.072,3.218-.047,6.438-.047,9.877,5.328-.822,4.491,2.98,4.6,6.017h9c-.039-3.149-.68-6.775,4.361-6.082",
    transform: "translate(-158.885 -38.494)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36019",
    "data-name": "Path 36019",
    d: "M323.065,84c-.669-.044-1.116-.07-1.562-.1-2.041-.152-2.916-.987-2.929-2.99q-.049-7.428,0-14.857c.014-1.977.936-2.946,2.955-2.958q11.186-.069,22.371,0c2.166.013,3.022.992,3.031,3.234.02,4.668.011,9.336,0,14,0,2.7-.681,3.4-3.382,3.582-.331.022-.658.1-1.121.166,0,1.064.048,2.084-.011,3.1-.111,1.9-.985,2.847-2.892,2.874q-6.744.1-13.49,0c-1.994-.026-2.869-.98-2.966-2.98-.047-.96-.008-1.925-.008-3.071m18.663-15.714H323.807V78.854c5.311-.878,4.268,3.055,4.428,5.988h9.056c.011-3.116-.712-6.821,4.437-6.027Z",
    transform: "translate(-208.922 -38.486)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36021",
    "data-name": "Path 36021",
    d: "M33.836,84.582c-1.669,0-3.339.015-5.008-.006-1.092-.014-1.679-.71-1.716-1.959-.04-1.314.571-2.183,1.676-2.194q5.055-.05,10.11,0c1.124.009,1.729.823,1.714,2.137S40,84.565,38.844,84.578c-1.669.018-3.339,0-5.008,0",
    transform: "translate(-13.956 -55.828)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36022",
    "data-name": "Path 36022",
    d: "M33.9,96.825c1.669,0,3.339-.016,5.008.006,1.1.015,1.671.705,1.705,1.969.035,1.321-.568,2.174-1.678,2.184q-5.055.049-10.11,0c-1.123-.01-1.729-.832-1.71-2.146.019-1.3.621-2,1.778-2.011,1.669-.017,3.339,0,5.008,0",
    transform: "translate(-13.957 -59.938)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36023",
    "data-name": "Path 36023",
    d: "M33.889,117.174c-1.67,0-3.34.01-5.009,0-1.124-.009-1.759-.751-1.777-2.032-.019-1.339.631-2.129,1.81-2.134q4.962-.018,9.924,0c1.127,0,1.758.758,1.774,2.044.018,1.342-.627,2.113-1.808,2.122-1.638.013-3.277,0-4.915,0",
    transform: "translate(-13.952 -65.568)",
    fill: "#005cbe",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.116dea38669324f1d1b3c055b65178f2.svg";
export { ForwardRef as ReactComponent };